// extracted by mini-css-extract-plugin
export default {"homeworkLine":"homeworkLine_homeworkLine__K5VKo","courseName":"homeworkLine_courseName__9RFFw","week":"homeworkLine_week__6sbwQ"};